import { Component, Input, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "no-content-msg",
  templateUrl: "./no-content-msg.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class NoContentMsgComponent {
  @Input() message: string;
  @Input() hidden: boolean;

  constructor() {}
}
